import type { ReactNode } from 'react';

export const symbol_text_increase: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m172-350-49 128q-4 10-12.56 16-8.55 6-19.44 6-19 0-29-15.5T59-248l192-488q5-11 14.16-17.5T285-760h30q11.45 0 20.22 6.5Q344-747 349-736l192 489q7 17-3.55 32-10.54 15-28.51 15-10.94 0-20.04-6.13-9.11-6.14-12.9-16.87l-48-127H172Zm24-64h208L302-685h-4L196-414Zm534-36H630q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100v-100q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v100h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H790v100q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-100Z"
		/>
	</svg>
);
